import React from 'react';
import { Card, CardHeader, CardSection, CardFooter } from '../../../components/ui/Card';
import Button from '../../../ui/Button';
import Textarea from '../../../ui/Textarea';

function EditImageWorkspace({ state }) {
  const onUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => state.setEditBaseImage(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className="edit-image-page__grid">
      <Card>
        <CardHeader title="Editar imagem" />
        <CardSection>
          <label className="edit-image-page__upload">
            <span>Carregar imagem base</span>
            <input type="file" accept="image/*" onChange={onUpload} />
          </label>

          <label className="edit-image-page__label" htmlFor="editPrompt">Prompt da edição</label>
          <Textarea
            id="editPrompt"
            rows={4}
            value={state.editPrompt}
            onChange={(event) => state.setEditPrompt(event.target.value)}
            placeholder="Descreva o que deseja alterar"
          />
        </CardSection>
        <CardFooter>
          <Button variant="primary" className="edit-image-page__cta" onClick={state.runEdit} disabled={state.isEditing}>
            {state.isEditing ? 'Processando...' : 'Processar edição'}
          </Button>
        </CardFooter>
      </Card>

      <Card>
        <CardHeader title="Pré-visualização" />
        <CardSection>
          {state.editedImage ? (
            <img className="edit-image-page__preview" src={state.editedImage} alt="Imagem editada" />
          ) : (
            <p className="edit-image-page__placeholder">A imagem editada aparecerá aqui.</p>
          )}
        </CardSection>
      </Card>
    </div>
  );
}

export default EditImageWorkspace;
